import { z } from "zod";

import { language } from "@rootreeweb/ns-helper";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";

import type { FormDefinition } from "../types.js";

import { consentTextEN } from "./shared.js";

const contactCreativeEN: FormDefinition = {
	signature: "617d2406ad2efebb6a700b107b742ba865675c2c98b960d529b3dbab51557c8a",
	formID: "contact-creative-en",
	schema: z.object({
		"First Name": z.string(),
		"Last Name": z.string(),
		Email: z.string().email(),
		Company: z.string(),
		Language: language,
		"Phone Number": z.string(),
		"What is your product and industry?": z.string(),
		"Are you starting from scratch or do you have a developed brand?": z
			.string()
			.optional(), // Whether you're looking for a package design update or a full branding experience, no project is too small or large for our Creative Team.
		"Where did you hear about us?": z.string().optional(),
		"What services can we help you with?": z
			.string()
			.optional()
			.describe(
				createCustomSettings({
					textArea: true,
				}),
			), // "Our team specializes in branding, package design, e-commerce websites, digital marketing, and so much more."
		"Please provide a link to your website and social media accounts": z
			.string()
			.optional()
			.describe(
				createCustomSettings({
					textArea: true,
				}),
			),
		"Anything else we should know?": z
			.string()
			.optional()
			.describe(
				createCustomSettings({
					textArea: true,
				}),
			),
		consentTextEN,
	}),

	submissionOptions: {
		subject: (formState) =>
			`Contact Creative Services Form: ${formState["First Name"]}`,
		preamble: "Submitted information",
		postamble:
			"Contact the Web Team if you have any issues with this the data in this email.",
		recipients: [
			"web@rootree.ca",
			"nicole.staios@rootree.ca",
			"design@rootree.ca",
		],
	},
	formOptions: {
		strings: {
			submitButton: "Send it in!",
			success:
				"Success! A member of our creative services team will be in touch shortly. If you need anything else, feel free to call us at 1-833-ROOTREE (766-8733).",
		},
	},
};
export default contactCreativeEN;
